export default {"src":"/_next/static/media/star.bfe2f5d5.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};